export default __webpack_public_path__ + "static/media/payment.d664a96e.png";